<!-- CLICK DERECHO -->
<div id="menuIzq" style="position: fixed;" 
  [style.left]="menuTopLeftPosition.x" 
  [style.top]="menuTopLeftPosition.y" 
  [matMenuTriggerFor]="rightMenu">
  <!-- standard material menu --> 
  <mat-menu #rightMenu="matMenu"> 
    <ng-template matMenuContent let-item="item"> 
      <button mat-menu-item (click)="deleteArchivo()">
        <mat-icon class="iconoMenVer" [ngStyle]="{'color':'grey'}">delete</mat-icon>
        {{'menu.eliminar' | translate}}
      </button> 
    </ng-template> 
  </mat-menu> 
</div> 

<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="aniosDisponibles"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="anioChange($event)"
  />
  <app-filters filtros
    [name]="'filtros.lider' | translate"
    [array]="responsables" [typeFilter]="Filters.SUCURSALES"
    [click]="false" [consolidado]="todasPer"
    (eventClick)="persChange($event)"
  />
  <app-filters filtros
    [name]="'filtros.res' | translate"
    [array]="responsablesAct" [typeFilter]="Filters.SUCURSALES"
    [click]="false" [consolidado]="todasPerAct"
    (eventClick)="persChangeAct($event)"
  />

  <div borrador [ngStyle]="{'color':'gray'}"
    (click)="borrarFiltro()" class="iconoMen" matTooltip="{{'tooltips.borrar-filtros'|translate}}">
      <img src="./../../../../assets/img/eraser.png">
  </div>

  <div contenido class="contenidoClass">
    <div class="w3-row zonaSelects">
      <div class="w3-row">
        <div class="w3-half" style="margin-right: 4vh;">
          <div class="texto">
            <div class="w3-right zonaTexto2">
              <span class="w3-right textoInputs"> {{'gestion.seguimiento.proy-estra.campo1' | translate}}</span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput">
              <select class="contentSelect" (change)="cambioPer()" [(ngModel)]="perSelect" [ngClass]="{'placeholderSelect': perSelect === ''}">
                <option value="" disabled hidden selected> {{'gestion.seguimiento.proy-estra.campo1TT' | translate}} </option>
                @for (opt of perspectives; track $index) {
                  <option value="{{opt.id}}" matTooltip="{{opt.name}}"> {{opt.name}} </option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="w3-row" style="padding-top: 1vh;">
        <!-- filtro objetivo -->
        <div [ngClass]="perSelect?'':'w3-disabled'" class="w3-half">
          <div class="texto">
            <div class="w3-right zonaTexto2">
              <span class="w3-right textoInputs"> {{'gestion.seguimiento.proy-estra.campo2' | translate}}</span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput">
              <select class="contentSelect" (change)="cambioObj()"[(ngModel)]="objSelect" [ngClass]="{'placeholderSelect': objSelect === ''}">
                <option value="" disabled hidden selected> {{'gestion.seguimiento.proy-estra.campo2TT' | translate}} </option>
                @for (opt of objectives; track $index) {
                  @if(perSelect === opt.perspective.id){
                    <option value="{{opt.id}}"  matTooltip="{{opt.name}}"> {{opt.name}} </option>
                  }                      
                }
              </select>
            </div>
          </div>
        </div>
        <!-- filtro estrategia -->
        <div [ngClass]="objSelect?'':'w3-disabled'" class="w3-rest">
          <div class="texto" style="width: fit-content!important;">
            <div class="w3-right zonaTexto2">
              <span class="w3-right textoInputs"> {{'gestion.seguimiento.proy-estra.campo3' | translate}}</span>
            </div>
          </div>
          <div class="w3-rest">
            <div class="zonaInput">
              <select class="contentSelect" (change)="cambioEst()" [(ngModel)]="proSelect" [ngClass]="{'placeholderSelect': proSelect === ''}">
                <option value="" disabled hidden selected> {{'gestion.seguimiento.proy-estra.campo3TT' | translate}} </option>
                @for (opt of programas; track $index) {
                  @if(perPrograma(opt)){
                    <option value="{{opt.id}}" matTooltip="{{opt.name}}"> {{opt.name}} </option>
                  }                      
                }
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="zonaGantt">
      <app-contenedor-elementos [header]="{title: ''}">
        <div iconos class="w3-right" style="margin-top: 0.3vh;">
          <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menu2">more_vert</mat-icon>
        </div>
        <mat-menu #menu2="matMenu">
          <button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar' | translate}}</span>
          </button>
          <button (click)="exportarExcelTodo()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            {{'gestion.seguimiento.proy-estra.optmenuExpEstatus' | translate}}
          </button>
          <button (click)="exportar_excelPer()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            {{'gestion.seguimiento.proy-estra.optmenuExpAcumulado' | translate}}
          </button>
          <button mat-menu-item (click)="$event.stopPropagation(); cambioDeFiltrado();">
            <div class="w3-quarter " style="padding-top: 3px; width: 15% !important;">
              <input type="checkbox" style="cursor: pointer;" [checked]="mostrarPeriodo">
            </div>
            <div class="w3-rest" style="padding-left: 0px;">{{'gestion.seguimiento.proy-estra.optmenuProyPer' | translate}}</div>
          </button>
        </mat-menu>

        <div body class="tabla">
          @if(!mostrarTable){
            <app-skeleton-table [columnas]="12" [filas]="10"/>
          }@else {
            <table class="tabla-aleema">
              <thead>
                <tr>
                  <th>
                    @if (expandirProg) {
                      <mat-icon class="iconoMen" matTooltip="{{'gestion.seguimiento.proy-estra.tooltipOcultarAll' | translate}}" matTooltipPosition="left" (click)="oculMostAll()">expand_less</mat-icon>
                    }@else {
                      <mat-icon class="iconoMen" matTooltip="{{'gestion.seguimiento.proy-estra.tooltipMostrarAll' | translate}}" matTooltipPosition="left" (click)="oculMostAll()">expand_more</mat-icon>
                    }
                  </th>
                  <th (click)="ordenamientoTabla()" class="contenedorSort" style="width: 20vw; cursor: pointer;">
                    {{'gestion.seguimiento.proy-estra.titTab1' | translate}}
                    @switch (ordenamiento) {
                      @case ('id') {<mat-icon class="iconoSortIni">sort_by_alpha</mat-icon>} 
                      @case ('asc') {<mat-icon class="iconoSortIni">vertical_align_bottom</mat-icon>} 
                      @case ('des') {<mat-icon class="iconoSortIni">vertical_align_top</mat-icon>} 
                    }
                  </th>
                  <th> {{'gestion.seguimiento.proy-estra.titTab2' | translate}} </th>
                  <th> {{'gestion.seguimiento.proy-estra.titTab3' | translate}} </th>
                  <th> {{'gestion.seguimiento.proy-estra.titTab4' | translate}} </th>
                  <th> {{'gestion.seguimiento.proy-estra.titTab5' | translate}} </th>
                  <th> {{'gestion.seguimiento.proy-estra.titTab6' | translate}} </th>
                  <th> {{'gestion.seguimiento.proy-estra.titTab7' | translate}} </th>
                  <th> {{'gestion.seguimiento.proy-estra.titTab8' | translate}} </th>
                  @if(verStats){
                    <th [matMenuTriggerFor]="menustats"> 
                      {{'gestion.seguimiento.proy-estra.titTab9' | translate}} </th>
                    <mat-menu #menustats="matMenu">
                      <button mat-menu-item (click)="verStats = !verStats">
                        <mat-icon class="iconoMen">visibility_off</mat-icon>
                        {{'gestion.seguimiento.proy-estra.tooltipOcultarAll' | translate}}
                      </button>
                      <button mat-menu-item (click)="$event.stopPropagation(); selecAllStatus();">
                        <div class="w3-quarter" style="padding-top: 3px; width: 25% !important;">
                          <input type="checkbox" style="cursor: pointer;" [checked]="allStats">
                        </div>
                        <div class="w3-rest" style="padding-left: 0px;">{{'filtros.selectAll' | translate}}</div>
                      </button>
                      @if(!allStats){
                        @for (st of estats; track $index) {
                          <button mat-menu-item (click)="$event.stopPropagation(); seleccionar(st)">
                            <div class="w3-quarter" style="padding-top: 3px;">
                              <input type="checkbox" style="cursor: pointer;" [checked]="st.check"
                              (click)="$event.stopPropagation();">
                            </div>
                            <div class="w3-rest" style="padding-left: 0px;">{{st.name}}</div>
                          </button>
                        }
                      }                 
                    </mat-menu>
                  }@else{
                    <th>
                      <mat-icon class="iconoMen" [ngStyle]="{'color':'grey'}" style="font-weight: bold; cursor: pointer;"
                        (click)="verStats = !verStats" fontSet="material-icons-outlined" matTooltip="{{'gestion.seguimiento.proy-estra.titTab9TT' | translate}}">visibility</mat-icon>
                    </th>
                  }
                  @if (actividades.length !== 0) {
                    @if(actividades[0].additions.length !== 0){
                      @for (ad of actividades[0].additions; track $index) {
                        <th>{{ad.name}}</th>
                      }
                    }
                  }
                </tr>
              </thead>
              @for (pro of proyectosMostrar; track $index) {
                @if (pro.actividades.length !== 0){
                  <tbody>
                    <tr style="font-weight: bold;">
                      <td>
                        @if (pro.check) {
                          <mat-icon class="iconoMen w3-button" matTooltip="{{'gestion.formulacion.proy-estra.tooltipOcultar' | translate}}" matTooltipPosition="left" (click)="oculMost(pro)">expand_less</mat-icon>
                        }@else {
                          <mat-icon class="iconoMen w3-button" matTooltip="{{'gestion.formulacion.proy-estra.tooltipMostrar' | translate}}" matTooltipPosition="left" (click)="oculMost(pro)">expand_more</mat-icon>
                        }
                      </td>
                      <td class="textoOverFlow" style="width: 20vw !important;"
                      [matTooltip]="pro.proyecto.name" [appOverflowTooltip]="pro.proyecto.name">
                        {{pro.proyecto.name}}
                      </td>
                      <td class="w3-center" style="min-width: 7vw; max-width: 20vw;">
                        <span>{{escribir_fecha(pro.fecha_ini)}}</span>
                      </td>
                      <td class="w3-center" style="min-width: 7vw; max-width: 23vw;">
                        <span>{{obtenerDias(pro.fecha_ini,pro.fecha_fin)}}</span>
                      </td>
                      <td class="w3-center" style="min-width: 7vw; max-width: 23vw;">
                        <span>{{escribir_fecha(pro.fecha_fin)}}</span>
                      </td>
                      <td class="textoOverFlow" style="min-width: 5vw; max-width: 20vw;"
                      [matTooltip]="pro.proyecto.responsible.position" [appOverflowTooltip]="pro.proyecto.responsible.position">
                        {{pro.proyecto.responsible.position}}
                      </td>
                      <td><br></td>
                      <td class="w3-center">{{pro.planeado}}</td>
                      <td class="w3-center" style="background-color: #e7e7e7;"
                        [ngClass]="pintarBordPro(pro.ejecutado,pro.planeado)">{{pro.ejecutado}}</td>
                      <td><br></td>
                      @if (actividades) {
                        @for (ad of actividades[0].additions; track ad; let i = $index) {
                          <td class="alinRight">{{escribirAdicionalPro(pro.actividades, i)}}</td>                        
                        }
                      }
                    </tr>
                    @if (pro.check) {
                      @for (act of pro.actividades; track $index) {                      
                        @if(resSelected(act) && (act.editable || !mostrarPeriodo) && estatusAct(act)){
                          <tr>
                            <td></td>
                            <td class="textoOverFlow" style="min-width: 5vw; max-width: 20vw;" [ngClass]="actividadRojo(act)"
                            [matTooltip]="act.name" [appOverflowTooltip]="act.name">
                              {{act.name}}
                            </td>
                            <td class="w3-center" style="min-width: 5vw; max-width: 20vw;">
                              {{escribir_fecha(act.initial_date)}}</td>
                            <td class="w3-center" style="min-width: 5vw; max-width: 20vw;">
                              {{obtenerDias(act.initial_date,act.end_date)}}</td>
                            <td class="w3-center" style="min-width: 5vw; max-width: 20vw;">
                              {{escribir_fecha(act.end_date)}}</td>
                            <td class="textoOverFlow" style="min-width: 5vw; max-width: 20vw;"
                            [matTooltip]="act.responsible.position" [appOverflowTooltip]="act.responsible.position">
                              {{act.responsible.position}}
                            </td>
                            <td class="w3-center">{{avanceAcumulado(act)}}</td>
                            <td class="w3-center">{{escribirDat(act.historico, 'plan')}}</td>
                            <ng-container *appRoles="permisos.SEGUIMIENTO">
                              @if (escribirDat(act.historico, 'ejec') === null && act.editable) {
                                <td [ngClass]="pintarBord(escribirDat(act.historico, 'ejec'),escribirDat(act.historico, 'plan'))"
                                class="textoOverFlow w3-center" style="background-color: #e7e7e7;" 
                                (dblclick)="editar(act.historico, act.id)" matTooltip="{{'gestion.seguimiento.proy-estra.tooltipCap' | translate}}">-</td>
                              }
                              @if (escribirDat(act.historico, 'ejec') !== null && act.editable) {
                                <td [ngClass]="pintarBord(escribirDat(act.historico, 'ejec'),escribirDat(act.historico, 'plan'))"
                                class="textoOverFlow w3-center" (dblclick)="editar(act.historico, act.id)"
                                style="background-color: #e7e7e7;" matTooltip="{{'gestion.seguimiento.proy-estra.tooltipCap' | translate}}">
                                  {{escribirDat(act.historico, 'ejec')}}
                                </td>
                              }
                              @if (escribirDat(act.historico, 'ejec') !== null && !act.editable) {
                                <td [ngClass]="pintarBord(escribirDat(act.historico, 'ejec'),escribirDat(act.historico, 'plan'))"
                                class="textoOverFlow w3-center" style="background-color: #e7e7e7;" 
                                    matTooltip="{{'gestion.seguimiento.proy-estra.tooltipCap' | translate}}">
                                  {{escribirDat(act.historico, 'ejec')}}
                                </td>
                              }                            
                            </ng-container>
                            <ng-container *appRolesNeg="permisos.SEGUIMIENTO">
                              @if (escribirDat(act.historico, 'ejec') === null) {
                                <td [ngClass]="pintarBord(escribirDat(act.historico, 'ejec'),escribirDat(act.historico, 'plan'))"
                                  class="textoOverFlow w3-center" style="background-color: #e7e7e7;">-</td>
                              }@else {
                                <td [ngClass]="pintarBord(escribirDat(act.historico, 'ejec'),escribirDat(act.historico, 'plan'))"
                                  class="textoOverFlow w3-center" style="background-color: #e7e7e7;">
                                  {{escribirDat(act.historico, 'ejec')}}
                                </td>
                              }
                            </ng-container>
                            <td class="textoOverFlow w3-center">
                              @if (verStats) {<div>{{obtEstatus(act)}}</div>}
                            </td>
                            @for (ad of act.additions; track $index) {
                              <ng-container *appRoles="permisos.SEGUIMIENTO">
                                @if (ad.type !== 'numero' && ad.type !== 'moneda' && ad.type !== 'archivo' && act.editable) {
                                  <td class="textoOverFlow w3-center" style="cursor: pointer;" (dblclick)="edicionAd(ad, act.id, $event)" 
                                    matTooltip="{{escribirAdicional(ad)}}">
                                    {{escribirAdicional(ad)}}
                                  </td>
                                }    
                                @if (ad.type !== 'numero' && ad.type !== 'moneda' && ad.type !== 'archivo' && !act.editable) {
                                  <td class="textoOverFlow alinRight" matTooltip="{{escribirAdicional(ad)}}">
                                    {{escribirAdicional(ad)}}
                                  </td>
                                }                              
                              </ng-container>
                              <ng-container *appRolesNeg="permisos.SEGUIMIENTO">
                                @if (ad.type !== 'numero' && ad.type !== 'moneda' && ad.type !== 'archivo') {
                                  <td class="textoOverFlow alinRight" matTooltip="{{escribirAdicional(ad)}}">
                                    {{escribirAdicional(ad)}}
                                  </td>
                                }                              
                              </ng-container>
                              @switch (ad.type) {
                                @case ('moneda') {
                                  <td class="textoOverFlow alinRight">
                                    <span matTooltip="{{escribirAdicional(ad)}}">{{escribirAdicional(ad)}}</span>
                                  </td>
                                }
                                @case ('numero') {
                                  <td class="textoOverFlow alinRight">
                                    <span matTooltip="{{escribirAdicional(ad)}}">{{escribirAdicional(ad)}}</span>
                                  </td>
                                }
                                @case ('archivo') {
                                  <td class="textoOverFlow w3-center">
                                    <div *appRoles="permisos.SEGUIMIENTO">
                                      @if (escribirAdicional(ad) !== '') {
                                        <div class="iconoArch" style="cursor: pointer;" (contextmenu)="onContextMenu($event, ad, act)" (click)="abirPDF(ad, $event);">
                                          <mat-icon matTooltip="{{escribirAdicional(ad)}}" class="iconoMen" [ngStyle]="{'color':'#4E9AC7'}">attach_file</mat-icon>
                                        </div>
                                      }@else {
                                        <div class="iconoArch" style="cursor: pointer;" (dblclick)="edicionAd(ad, act.id, $event)">
                                          <mat-icon  matTooltip="{{'gestion.seguimiento.proy-estra.tooltipAdj' | translate}}" class="iconoMen" [ngStyle]="{'color':'#C8C7C8'}">attach_file</mat-icon>
                                        </div>
                                      }                                    
                                    </div>
                                    <div *appRolesNeg="permisos.SEGUIMIENTO">
                                      @if (escribirAdicional(ad) !== '') {
                                        <div class="iconoArch" style="cursor: pointer;" (click)="abirPDF(ad, $event);">
                                          <mat-icon matTooltip="{{escribirAdicional(ad)}}" class="iconoMen" [ngStyle]="{'color':'#4E9AC7'}">attach_file</mat-icon>
                                        </div>
                                      }@else {
                                        <div class="iconoArch">
                                          <mat-icon class="iconoMen" [ngStyle]="{'color':'#C8C7C8'}">attach_file</mat-icon>
                                        </div>
                                      }
                                    </div>
                                  </td>
                                }
                              }
                            }
                          </tr>
                        }                      
                      }
                    }
                  </tbody>
                }
              }
            </table>
          }
        </div>
      </app-contenedor-elementos>
    </div>
  </div>
</app-esqueleto-tableros>